import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { LS2PAC_Utils } from "../utils/Utils";

export const RequestsClientManager = (function( $ ) {

	var restUrl = LS2PAC_CONSTANTS.restUrls.requests, filteredHolds = [];

	const submitRequestEvent = LS2PAC_CONSTANTS.Events.onSubmitRequest;

	TLCEventManager.addListener( submitRequestEvent, function( event ) {
		if( event.isTitleLevel === false ) {
			onRequest( filterItemLevelRequest( event.data, event.pickupBranchId ) );
		}
		else {
			onRequest( filterTitleLevelRequest( event.data, event.pickupBranchId ) );
		}
	} );

	var getPlaceHoldInfo = function( resource, pickupBranchId, isTitleLevelHold ) {
		return {
			bibliographicId: isTitleLevelHold ? resource.hostBibliographicId : resource.barcode,
			pickupBranchId:  pickupBranchId,
			titleLevelHold:  isTitleLevelHold.toString(),
			interfaceType:   "PAC",
			downloadable:    resource.downloadable,
			serialItem:		isTitleLevelHold ? resource.serial : resource.serialItem
		};
	};

	// TODO: this function says its not being used
	var isTitleAvailable = function( resource ) {
		var isAvailable = false;
		$.each( resource.holdingsInformations, function( i, holdingsInformation ) {
			if( holdingsInformation.available === true ) {
				isAvailable = true;
				return false;
			}
		} );
		return isAvailable;
	};

	var filterTitleLevelRequest = function( resources, pickupBranchId ) {//this will work for title level
		var holdsToPlace = [];
		filteredHolds = [];
		$.each( resources, function( i, resource ) {
				if( resource.rtype !== 1 ) {
					filteredHolds.push( $.extend( {
						success:    false,
						message:    '<BadResourceType>',
						shortTitle: resource.shortTitle
					}, getPlaceHoldInfo( resource, pickupBranchId, true ) ) );
				}
				else if( resource.downloadable === true && !resource.canCheckout ) {
					filteredHolds.push( $.extend( {
						success:    false,
						message:    '<BadResourceType>',
						shortTitle: resource.shortTitle
					}, getPlaceHoldInfo( resource, pickupBranchId, true ) ) );
				}
				else if( ApplicationData.locationConfiguration.getAllowHolds().onShelf === false && LS2PAC_Utils.isResourceAvailableLocally( resource ) ) {
					filteredHolds.push( $.extend( {
						success:    false,
						message:    '<OnShelfError>',
						shortTitle: resource.shortTitle
					}, getPlaceHoldInfo( resource, pickupBranchId, true ) ) );
				}
				else {
					holdsToPlace.push( getPlaceHoldInfo( resource, pickupBranchId, true ) );
				}
			}
		);
		return holdsToPlace
	};

	var filterItemLevelRequest = function( resources, pickupBranchId ) {
		//rtype and downloadable are handled in the view.
		var holdsToPlace = [];
		filteredHolds = [];
		var availabilityBranch = ApplicationData.getBranchToUseForAvailability();

		$.each( resources, function( i, resource ) {
			if( ApplicationData.locationConfiguration.getAllowHolds().onShelf === false && resource.available === true && availabilityBranch === parseInt(resource.branchIdentifier, 10) ) {
				filteredHolds.push( $.extend( {
					success: false,
					message: '<OnShelfError>'
				}, getPlaceHoldInfo( resource, pickupBranchId, true ) ) );
			}
			else {
				holdsToPlace.push( getPlaceHoldInfo( resource, pickupBranchId, false ) );
			}
		} );
		return holdsToPlace;
	};

	var onRequest = function( postData ) {
		var limitTitleLevelHoldsToPatronBranch = ApplicationData.locationConfiguration.getAllowHolds().restrictTitle;
		try {
			TLCRest.jsonCall( restUrl + limitTitleLevelHoldsToPatronBranch, {
				postData: postData,
				callback: function( placeHoldReturn ) {
					TLCLogger.log( "placeHoldReturn", placeHoldReturn );
					TLCLogger.log( "filteredHolds", filteredHolds );

					var allHoldReturn = placeHoldReturn.placeHoldInfos.concat( filteredHolds );
					placeHoldReturn.placeHoldInfos = allHoldReturn;
					TLCLogger.log( "allHoldReturn", allHoldReturn );
					AccountHolder.fetchAccountSummaryAndPatron(true);
					TLCEventManager.fireEvent( LS2PAC_CONSTANTS.Events.onRequestResponse, {
						data: placeHoldReturn
					} );
				}
			} );
		}
		catch( e ) {
			TLCLogger.log( "exception", e );
		}
	};

	return {
		submitRequestEvent: submitRequestEvent
	};

})( jQuery );
